import React from 'react';
import PropTypes from 'prop-types';

import { scientificFormat } from '../../utils/helpers/formatting';

const PlatformLink = ({ href, icon, handle, count }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={e => e.stopPropagation()}
    style={{ display: 'flex', alignItems: 'center', margin: '3px 0', color: 'inherit' }}
  >
    {icon}
    <span style={{ marginLeft: 8 }}>
      @{handle}
      <span style={{ color: '#9090a0', marginLeft: 6 }}>{scientificFormat(count)}</span>
    </span>
  </a>
);

PlatformLink.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  handle: PropTypes.string,
  count: PropTypes.number,
};

PlatformLink.defaultProps = {
  handle: '',
  count: 0,
};

export default PlatformLink;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/platform-link.js
 **/